// extracted by mini-css-extract-plugin
export default {"root":"tabs-module--root--80455","centerAligned":"tabs-module--center-aligned--49ca0","tab":"tabs-module--tab--69e99","selected":"tabs-module--selected--3730c"};